"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastViewport = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ToastPrimitive = require("@radix-ui/react-toast");
const classNames_1 = require("../../../../../utils/classNames");
exports.ToastViewport = (0, react_1.forwardRef)(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)(ToastPrimitive.Viewport, { ref: ref, className: (0, classNames_1.cn)('fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]', className), ...props })));
